// Pet presets (D10): one-tap starting points shown as a row at the top of the controls ("เริ่มจาก
// แบบสำเร็จ"). PURE — a preset is a document transform only; the page (src/main.js) owns the ONE
// undo step, the RESET_WARNING confirm for a custom layout, and returning to simple mode.
//
// Colours are @3dp/core FILAMENTS/BRAND entries, taken BY NAME (D7: a preset is a filament a pet owner
// can buy; an own colour is the visitor's own pick — unify-ui ship 4b, R89):
//   dog   FILAMENTS Blue  #1F5FBF + White #FFFFFF
//   cat   BRAND Filasophy Violet #7B4FD3 + White #FFFFFF
//   paw   FILAMENTS Orange #F26A1B + Black #111111
//   heart FILAMENTS Red   #E3242B + White #FFFFFF
//
// cat and heart use icon-name-phone-back (not icon-name): icon + name on the front, phone on the
// back — so, unlike the plain icon-name template, a typed phone number is not silently dropped
// (final review defect: cat/heart used to lose the phone entirely).
import { applyChange } from './doc.js';

export const PRESETS = [
  { id: 'dog', shape: 'bone', template: 'name-front-phone-back', color: '#1F5FBF', textColor: '#FFFFFF' },
  { id: 'cat', shape: 'cat', template: 'icon-name-phone-back', iconId: 'cat', color: '#7B4FD3', textColor: '#FFFFFF' },
  { id: 'paw', shape: 'paw', template: 'name-phone', color: '#F26A1B', textColor: '#111111' },
  { id: 'heart', shape: 'heart', template: 'icon-name-phone-back', iconId: 'heart', color: '#E3242B', textColor: '#FFFFFF' },
];
export const PRESET_IDS = PRESETS.map(p => p.id);

// (doc, id) → doc. Sets shape, template, colours and (icon templates) the icon id; KEEPS whatever
// name/phone text was already typed, wherever the new template's roles put it (doc.js `template`'s
// own `keep` picks an existing element up by id from either face) — and forces raised front text
// (frontMode) so the two colours actually show: every preset's textColor ≠ color, and an engraved
// front prints in the tag colour regardless of textColor (src/doc.js colourNote / D8).
export function applyPreset(doc, id) {
  const preset = PRESETS.find(p => p.id === id);
  if (!preset) throw new Error('unknown preset: ' + id);
  let out = applyChange(doc, { type: 'shape', shape: preset.shape });
  out = applyChange(out, { type: 'template', template: preset.template });
  out = applyChange(out, { type: 'frontMode', frontMode: 'raised' });
  out = applyChange(out, { type: 'color', color: preset.color });
  out = applyChange(out, { type: 'textColor', textColor: preset.textColor });
  if (preset.iconId) out = applyChange(out, { type: 'icon', face: 'front', id: 'icon', iconId: preset.iconId });
  return out;
}

// doc → preset id | null. PURE identity check — replaces a stateful "last preset applied" flag the
// page used to keep for the D14 download beacon (final review defect: it stayed set after a manual
// colour/icon change silently diverged the doc from the preset it named, over-reporting that preset
// on every later download until a manual SHAPE or TEMPLATE pick happened to clear it). A doc "is"
// preset p exactly while its shape, template, color, textColor and (for an icon preset) the front
// icon's iconId all still equal p's — any other field (typed text, hole style, thickness, frontMode,
// an added element…) does not change the answer, since those are not part of what a preset sets.
export function presetOf(doc) {
  for (const p of PRESETS) {
    if (doc.shape !== p.shape) continue;
    if (doc.layout.template !== p.template) continue;
    if (doc.color !== p.color) continue;
    if (doc.textColor !== p.textColor) continue;
    if (p.iconId) {
      const icon = doc.front.find(e => e.id === 'icon');
      if (!icon || icon.iconId !== p.iconId) continue;
    }
    return p.id;
  }
  return null;
}
